import useScrollAnimation from "@/hooks/useScrollAnimation";
import { metricsData } from "@/mocks/homeData";

export default function MetricsSection() {
  const { ref, isVisible } = useScrollAnimation(0.12);

  return (
    <section className="w-full py-16 md:py-24 bg-foreground-950">
      <div
        ref={ref}
        className={`w-full px-4 md:px-6 lg:px-10 transition-all duration-700 ${
          isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
        }`}
      >
        <div className="text-center max-w-3xl mx-auto mb-10 md:mb-14">
          <span className="text-xs md:text-sm font-semibold text-accent-500 uppercase tracking-widest">
            {metricsData.label}
          </span>
          <h2 className="font-heading font-bold text-xl md:text-3xl lg:text-4xl text-background-50 mt-3 leading-tight">
            {metricsData.headline}
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4 max-w-6xl mx-auto">
          {metricsData.metrics.map((metric) => (
            <div
              key={metric.label}
              className="bg-foreground-900/40 rounded-xl p-4 md:p-5 border border-foreground-800/50 text-center hover:border-accent-500/30 transition-all"
            >
              <div className="font-heading font-bold text-xl md:text-3xl text-accent-400 leading-none mb-2">
                {metric.value}
              </div>
              <div className="text-xs md:text-sm font-semibold text-background-200 mb-1 leading-snug">
                {metric.label}
              </div>
              <div className="text-xs text-background-500 leading-tight">
                {metric.detail}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}